// extracted by mini-css-extract-plugin
module.exports = {"headerIcon":"AuthButton_headerIcon__3TeHR","userImg":"AuthButton_userImg__1bQ8C","loginImg":"AuthButton_loginImg__1pU9Q","headerTextIcon":"AuthButton_headerTextIcon__3iAIr"};